import React, { useEffect, useState } from "react";
import MapComponent from "../components/MapComponent";
import { useUploadStore } from "../stores/videoUploadStore";
import {
  ChevronLeft,
  ChevronRight,
  FileText,
  LayoutGrid,
  Play,
} from "lucide-react";

const InteractiveMap = ({ data, rowData }) => {
  const { fetchVideoData, data: videoData } = useUploadStore();
  const [detectedObjectsName, setDetectedObjectsName] = useState([]);
  const [currentTime, setCurrentTime] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");

  useEffect(() => {
    fetchVideoData(data?._id);
  }, [data?._id, fetchVideoData]);

  const sortedVideos = Array.isArray(videoData)
    ? videoData.sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt))
    : [];

  const mostRecentVideo = sortedVideos.length > 0 ? sortedVideos[0] : null;

  const getDetectedObjectsName = (videoData) => {
    let objectName = videoData?.map((video) => video.detectedObjects);

    if (mostRecentVideo) {
      objectName = mostRecentVideo.detectedObjects;
    }

    setDetectedObjectsName(objectName);
  };

  useEffect(() => {
    getDetectedObjectsName(videoData);
  }, [videoData]);

  const defectsNameArr = Array.isArray(detectedObjectsName)
    ? detectedObjectsName.map((item) => item?.label)
    : [];
  const token = localStorage.getItem("token"); // Retrieve the token
  return (
    <>
      <div className="flex-1">
        <MapComponent surveyId={data?._id} selectedFilter={selectedFilter} />
      </div>
      <div className="flex flex-row h-full">
        <div className="flex-1 mt-5">
          {mostRecentVideo && (
            <div
              key={mostRecentVideo?._id}
              className="h-[50vh] overflow-hidden"
            >
              <video controls autoPlay className="h-full w-full">
                <source
                  src={`${process.env.REACT_APP_API_URL}api/videos/player/${mostRecentVideo?.processedPath}?token=${token}`}
                  type="video/mp4"
                />
              </video>
            </div>
          )}

          <div className="">
            {/* Header */}
            <div className="flex border-b justify-between items-center pb-2">
              <div className="flex gap-2 items-center">
                <span className="text-gray-800 text-lg font-semibold">
                  {mostRecentVideo?.videoLabel || "No Label"}{" "}
                  {/* Display video label */}
                </span>
              </div>
              <div className="flex gap-3 items-center">
                <Play size={20} className="text-gray-600 cursor-pointer" />
                <FileText size={20} className="text-gray-600 cursor-pointer" />
                <LayoutGrid
                  size={20}
                  className="text-gray-600 cursor-pointer"
                />
                <ChevronLeft
                  size={20}
                  className="text-gray-600 cursor-pointer"
                />
                <ChevronRight
                  size={20}
                  className="text-gray-600 cursor-pointer"
                />
              </div>
            </div>

            {/* Details Section */}
            <div className="">
              <div className="grid grid-cols-2 gap-4 mt-4">
                <div>
                  <p className="text-gray-500 text-sm">Location</p>
                  <p className="text-gray-800 font-semibold">
                    {rowData?.roadName}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 text-sm">Date Time</p>
                  <p className="text-gray-800 font-semibold">{currentTime}</p>
                </div>
              </div>
              <div>
                <p className="text-gray-500 text-sm">Defects</p>
                <p className="text-gray-800 font-semibold">
                  {defectsNameArr.join(", ")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InteractiveMap;
